import React, { useState, useEffect } from 'react';
import { FaInstagram, FaTwitter, FaFacebook, FaEnvelope, FaStar } from 'react-icons/fa';
import { MdBookmarkBorder } from 'react-icons/md';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import * as AppUrls from "../../../constants/AppUrls";
import styles from './CopyPeople.module.css'; // Import the CSS module



const CopyPeople = ({ profile , isDarkMode }) => {
  
  const { i18n } = useTranslation();

  let ml2Localized = "ml-2";
  let leftLocalized = "left";
  let dir = "ltr";
  if (i18n.language === "ar") {
    ml2Localized = "mr-2";
    leftLocalized = "right";
    dir = "rtl";
  }


  const riskColor = profile.risk < 5 ? '#0c9801' : profile.risk > 5 ? '#ee0000' : '#007bff';

  const CopyerColor = profile.risk <= 5 ? '#0c9801' : '#ee0000';


  return (

    <Link  to={AppUrls.CopyPeopleProfileListWorkspace} style={{textDecoration: "none"}}>


      <div className={`${styles.first}`}
        style={{
          background: isDarkMode ? "#000": "white"
        }}

      >
        <div className={`${styles.second}`}>
          <div className={`${styles.third}`}>
            {/* Profile Image with SVG circle as frame */}
            <div style={{ position: 'relative', alignSelf: 'center' }}>
              <svg height="100" width="100" style={{ borderRadius: "50%", overflow: "hidden" }}>
                <circle cx="50" cy="50" r="45" stroke={riskColor} strokeWidth="3" fill="transparent" />
              </svg>
              <img src={profile.image} alt={`${profile.name} profile`} className={`${styles.four}`} />
              <div className={`${styles.five}`} style={{
                backgroundColor: isDarkMode ? "#000": "white",
                border: `1px solid ${riskColor}`
              }}>
                <FaStar color={riskColor} style={{
                  fontSize: "10px"
                }} />
              </div>
            </div>
            <div className={`${styles.six}`}>
              <div style={{ fontWeight: "bold", fontSize: "16px" }}>{profile.name}</div>
              <div style={{ fontSize: "11px", color: "gray" }}>{profile.region}</div>
              <div className={`${styles.seven}`} style={{backgroundColor: riskColor }}>
                <div className={`${styles.eight}`} style={{ color: riskColor, backgroundColor: isDarkMode ? "#000": "white", border: `1px solid ${riskColor}` }}>RISK</div>
                <div className={`${styles.nine}`} style={{ border: `1px solid ${riskColor}`}}>{profile.risk}</div>
              </div>
            </div>
          </div>

          <div className={`${styles.ten}`}>
            <MdBookmarkBorder size={28} color="gray" style={{ cursor: "pointer", position: "absolute", top: "20px", right: i18n.language === "ar" ? "" : "20px" }} />
            <div className={`${styles.eleven}`}>
              <div className={`${styles.twelve}`}>{profile.return}%</div>
              <div style={{ fontSize: "11px", color: "gray" }}>RETURN (LAST 12 MONTHS)</div>
            </div>
          </div>
        </div>

        <div className={`${styles.thirteen}`}>
          <div style={{ display: "flex" }}>
            <FaInstagram className={`${styles.fourteen}`} />
            <FaTwitter className={`${styles.fourteen}`} />
            <FaFacebook className={`${styles.fourteen}`} />
            <FaEnvelope className={`${styles.fourteen}`} />
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", flexDirection: "column", marginRight: "10px" }}>
              <span style={{ fontWeight: "bold" }}>{profile.copiers} COPIERS</span>
              <span style={{ fontSize: "15px", color: CopyerColor }}>^{profile.copyPercentage}%</span>
            </div>
            <button className={`${styles.button}`}>
              COPY
            </button>
          </div>
        </div>
      </div>



    </Link>
  );
};

export default CopyPeople
